import { createFileRoute, useNavigate } from '@tanstack/react-router'

import { AiListingJobsPage } from '@/components/AiListing/AiListingJobsPage'
import { jobsSearchSchema, withoutJobsSearchDefaults } from '@/components/AiListing/search'

/**
 * Wiring only. The schema and the default-pruning live beside the page in
 * `search.ts`, where they are covered.
 */
export const Route = createFileRoute('/_app/ai-listing/')({
  validateSearch: jobsSearchSchema,
  component: AiListingRoute,
})

function AiListingRoute() {
  const search = Route.useSearch()
  const navigate = useNavigate({ from: Route.fullPath })

  return (
    <AiListingJobsPage
      search={search}
      onSearchChange={(next) =>
        void navigate({
          search: (current) => withoutJobsSearchDefaults({ ...current, ...next }),
          // Changing what is shown, not going somewhere new.
          replace: true,
        })
      }
      // A new job is a different thing: push, so Back returns to the list.
      onJobStarted={(job) => void navigate({ to: '/ai-listing/$jobId', params: { jobId: job.id } })}
    />
  )
}
